/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { TabMenu } from 'primereact/tabmenu';
import { withAccount } from '../../../components/AccountContext';
import Detail from './DetailContainer';
import SurveyDataContainer from './components/SurveyData/SurveysDataContainer';
import { getObjectFromQueryParam, regenerateUrlWithQuery } from '../../../utils/UrlUtil';
import { Pagination } from '../../../shared/Constants';
import Data from './components/Data/DataContainer';
import { validatePageSize } from '../../../components/gr8piDataTable/Gr8piDataTable';
import Boundary from '../../../components/ErrorBoundary';
import ArrayUtil from '../../../utils/ArrayUtil';
import { intlShape } from '../../../components/prop-types';
import SurveyProjectReports from '../reports/SurveyProjectReports';

const messages = defineMessages({
  detail: { id: 'super_survey.detail', defaultMessage: 'Details' },
  surveys: { id: '360.plural', defaultMessage: 'Surveys' },
  definitions: { id: 'super_survey.definitions', defaultMessage: 'Definitions' },
  reports: { id: 'super_survey.reports', defaultMessage: 'Reports' },
});

class SurveyProjectDetailContainer extends Component {
  constructor(props) {
    super(props);
    const { queryObject } = props;

    const tagList = queryObject && queryObject.tags ? queryObject.tags : [];
    let tags = [];
    if (tagList && !Array.isArray(tagList)) {
      tags = [tagList];
    } else {
      tags = tagList;
    }
    const { pageSize, pageSizeLast } = queryObject;
    const pageSizeValidate = validatePageSize(queryObject, pageSize, pageSizeLast);
    const { pageSizeState, pageSizeLastState, pageSizenumber } = pageSizeValidate;
    this.state = {
      tabs: [],
      activeItem: null,
      paginationFilter: {
        tab: queryObject && queryObject.tab ? queryObject.tab : 'DEFINITIONS',
        pageSize: pageSizeState,
        query: queryObject && queryObject.query ? queryObject.query : null,
        tags,
        cursorEnd: queryObject && queryObject.cursorEnd ? queryObject.cursorEnd : null,
        pageSizeLast: pageSizeLastState,
        cursorStart: queryObject && queryObject.cursorStart ? queryObject.cursorStart : null,
      },
      pageSizenumber,
    };
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.ChangeTabStatus = this.ChangeTabStatus.bind(this);
    this.handleTagsChange = this.handleTagsChange.bind(this);
    this.setpage = this.setpage.bind(this);
    this.setPageSize = this.setPageSize.bind(this);
    this.resetUrlPagi = this.resetUrlPagi.bind(this);
    this.changeTab = this.changeTab.bind(this);
  }

  componentDidMount() {
    this.setupTab();
  }

  setupTab() {
    const { intl: { formatMessage } } = this.props;

    const tabs = [
      {
        id: 'DETAIL',
        label: formatMessage(messages.detail),
        icon: 'pi pi-home',
      },
      {
        id: 'SURVEYS',
        label: formatMessage(messages.surveys),
        icon: 'pi pi-list',
      },
      {
        id: 'DEFINITIONS',
        label: formatMessage(messages.definitions),
        icon: 'pi pi-file',
      },
      {
        id: 'REPORTS',
        label: formatMessage(messages.reports),
        icon: 'pi pi-file-o',
      },
    ];

    this.setState({ tabs });
  }

  setpage(fetchEntries, next_value, previous_value) {
    const { paginationFilter } = this.state;
    const { pageSizenumber } = this.state;
    if (fetchEntries === Pagination.NEXT) {
      paginationFilter.pageSize = pageSizenumber;
      paginationFilter.cursorEnd = next_value;
      paginationFilter.pageSizeLast = null;
      paginationFilter.cursorStart = null;
    } else if (fetchEntries === Pagination.PREV) {
      paginationFilter.pageSizeLast = pageSizenumber;
      paginationFilter.cursorStart = previous_value;
      paginationFilter.pageSize = null;
      paginationFilter.cursorEnd = null;
    }
    this.updateUrlPagi(paginationFilter);
  }

  setPageSize(numberPageSize) {
    this.setState({ pageSizenumber: numberPageSize });
    const { paginationFilter } = this.state;
    paginationFilter.pageSize = numberPageSize;
    const orderBy = ['cursorEnd', 'pageSizeLast', 'cursorStart'];
    this.resetUrlPagi(paginationFilter, orderBy);
    this.updateUrlPagi(paginationFilter);
  }

  changeTab(event) {
    this.setState({ activeItem: event.value });
  }

  ChangeTabStatus(value) {
    const { paginationFilter } = this.state;
    paginationFilter.tab = value;
    this.setState({ paginationFilter });

    const { history } = this.props;
    const oldPath = history.location;
    const newPath = regenerateUrlWithQuery(oldPath.pathname, paginationFilter, ['pageSize']);
    history.replace(newPath);
  }

  handleFilterChange(event) {
    const { history } = this.props;
    const { target } = event;
    const { name } = target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    const { paginationFilter } = this.state;
    paginationFilter[name] = value;
    this.setState({ paginationFilter });

    const oldPath = history.location;
    const newPath = regenerateUrlWithQuery(oldPath.pathname, paginationFilter, ['pageSize']);
    history.replace(newPath);
  }

  handleTagsChange(value) {
    const { history } = this.props;
    const { paginationFilter } = this.state;
    paginationFilter.tags = value;
    this.setState({ paginationFilter });

    const oldPath = history.location;
    const newPath = regenerateUrlWithQuery(oldPath.pathname, paginationFilter, ['pageSize']);
    history.replace(newPath);
  }

  resetUrlPagi(paginationFilter, orderBy) {
    if (ArrayUtil.isNotEmpty(orderBy)) {
      orderBy.map((value) => {
        paginationFilter[value] = null;
        return paginationFilter;
      });
    }
  }

  updateUrlPagi(paginationFilter) {
    this.setState({ paginationFilter });
    const { history } = this.props;
    const oldPath = history.location;
    const newPath = regenerateUrlWithQuery(oldPath.pathname, paginationFilter);
    history.replace(newPath);
  }

  render() {
    const { currentAccount, match } = this.props;
    const { params: { surveyProjectId } } = match;
    const { tabs, activeItem } = this.state;
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <div className="p-grid">
              <div className="p-col">
                <TabMenu
                  model={tabs}
                  activeItem={activeItem}
                  onTabChange={this.changeTab}
                />
              </div>
            </div>
            {(!activeItem || activeItem.id === 'DETAIL') && (
              <Boundary>
                <Data {...this.props} />
              </Boundary>
            )}
            {activeItem && activeItem.id === 'SURVEYS' && (
              <Boundary>
                <SurveyDataContainer />
              </Boundary>
            )}
            {activeItem && activeItem.id === 'DEFINITIONS' && (
              <Boundary>
                <Detail currentAccount={currentAccount} match={match} />
              </Boundary>
            )}
            {activeItem && activeItem.id === 'REPORTS' && (
              <Boundary>
                <SurveyProjectReports accountId={currentAccount} surveyProjectId={surveyProjectId} />
              </Boundary>
            )}
          </div>
        </div>
      </div>
    );
  }
}

SurveyProjectDetailContainer.propTypes = {
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  queryObject: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { history } = ownProps;
  const { search } = history.location;
  const queryObject = getObjectFromQueryParam(search);
  return {
    ...ownProps,
    queryObject,
  };
};
export default injectIntl(
  withRouter(
    connect(
      mapStateToProps,
      null,
    )(withAccount(SurveyProjectDetailContainer)),
  ),
);
